import 'babel-polyfill'
import 'es6-promise/auto'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import md5 from 'js-md5';
import VueResource from 'vue-resource'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import JSEncrypt from "jsencrypt"; //引入模块
Vue.prototype.$jsEncrypt = JSEncrypt; //配置全局变量
// import Message from "element-ui/packages/message/src/main";
Vue.prototype.$axios = axios;
Vue.config.devtools = true;
Vue.use(VideoPlayer)
Vue.prototype.$md5 = md5;
Vue.use(ElementUI);
// 绑定 vue-resource（ajax）
Vue.use(VueResource);



/**
 * 生成随机文件名称
 * 规则八位随机字符，加下划线连接时间戳
 */
export const getFileNameUUID = () => {
  function rx() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }

  return `${+new Date()}_${rx()}${rx()}`
}
let system = "";
let logPathList = ["/userCenter", "/studyPage", "/userClasses", "/userItemDetail", "/userClassDetail", "/userSetting", "/applyClassList",
  "/finishClassList", "/study", "/topicDetail", "/topicDetailAdd", "/applyclass", "/classes", "/myClass", "/registerManager", "/studyManager",
  "/reportManager", "/classDetail", "/classList", "/classReport", "/courseUpload", "/classUpload", "/noticeInformation", "/repeatApply",
  "/wordListPage","/personPage","/historyScorePage","/otherScorePage","/licensePage","/personInformationPage","/pwdChangePage"
,"/wordListPage","/wordPage","/myCenterPage","/zzrdqkPage","/sysrkqkPage","/nlyzqkPage","/orgPartyPage","/personAssistantPage"
  ,"/assistantPage","/administrativePage","/annualCheckPage","/orgInformationPage"];
router.beforeEach((to, from, next) => {

  if (logPathList.indexOf(to.path) >= 0) { // 验证是否需要登陆
    if ((localStorage.getItem('access_token') && getUrlKey("sys") !== "ucap") || (system === "ucap")) { // 查询本地存储信息是否已经登陆

      if(new Date().getTime()  > localStorage.getItem('expires')){
        Vue.prototype.$message({
          duration: 2000,
          type: 'error',
          message: '登录过期，请重新登录!'
        });
        //已过期
        localStorage.clear();
        next({
          path: '/login', // 未登录则跳转至login页面
          query: {redirect: to.fullPath}, // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
        });
      }
      system = "";
      next();
    } else {
      if ("ucap" === getUrlKey("sys")) {
        localStorage.clear();
        var username = getUrlKey("username");
        axios({
          url: 'api/sfpro/authentication/getUcapToken?account=' + username,
          method: 'get',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
        }).then(res => {
          if (200 === res.status) {
            localStorage.setItem('sid', username);
            localStorage.setItem('access_token', res.data.data.accessToken);
            localStorage.setItem("role", "judicial");
            localStorage.setItem("nickname", res.data.data.nickname);
            localStorage.setItem("orgid", res.data.data.orgid);
            //设置创建时间
            localStorage.setItem("startTime",new Date().getTime());
            //24小时清除一下缓存  86400000
            //设置过期时间
            localStorage.setItem("expires",new Date().getTime()+86400000 );
            Vue.prototype.$message({
              duration: 2000,
              type: 'success',
              message: '登录成功!'
            });
            system = getUrlKey("sys");//跳出循环
            next({path: '/studyPage'});
          } else {
            Vue.prototype.$message({
              duration: 2000,
              type: 'error',
              message: '用户名或密码错误!'
            });
            next({
              path: '/login', // 未登录则跳转至login页面
              query: {redirect: to.fullPath}, // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
            });
          }
        });
      } else {
        localStorage.clear();
        next({
          path: '/login', // 未登录则跳转至login页面
          query: {redirect: to.fullPath}, // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
        });
      }
    }
  } else {
    next();
  }
});
var flag = true;
axios.interceptors.response.use(response=>{
  return response;
},error => {

  if(error.response.data.code === 403){
    //与后台约定登录失效的返回码,根据实际情况处理
    localStorage.clear();     //删除用户信息
    //如果超时就处理 ，指定要跳转的页面(比如登陆页)
    if(flag){
      flag = false;
      Message({
        message: '认证过期,请重新登录!',
        type: 'warning',
        duration: 1000,
        center: true,
        onClose: function () {
          flag = true;
          router.push('/login');
        }
      });
    }

  }else if(error.response.status===401){
    localStorage.clear();     //删除用户信息
    //如果超时就处理 ，指定要跳转的页面(比如登陆页)
    router.push('/login');
  }else if(error.response.status===400){
    Message({
      message: '系统错误!',
      type: 'warning',
      center: true
    });
  }
  return Promise.resolve(error.response)
});



new Vue({
  el: '#app',
  render: h => h(App),
  router
});

axios.interceptors.request.use((config) => {
  // 请求发送前的处理逻辑
  if(localStorage.getItem("access_token")&&localStorage.getItem("access_token")!=="undefined"){
    config.headers.Authorization = "bearer " + localStorage.getItem("access_token");
  }
  return config;
});


export function getUrlKey(name) {
  const url = window.location.href;
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
}










// WEBPACK FOOTER //
// ./src/main.js